module.exports = __webpack_public_path__ + "img/tweed_14_10_b.fe225da7.jpg";